<template>
  <div class="delrylb-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.searchUser" style="width:200px" placeholder="关键字搜索" @keyup.enter.native="SearchUser"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="SearchUser">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button type="primary" @click="addUser" icon="el-icon-plus">添加用户</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loadingUser">
                <el-table
                  :data="tableDataUser"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="登录名"
                    width="180"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.username}}</span>
                      <el-tag :disable-transitions="true" type="warning" size="mini" v-if="scope.row.userid==delinfo.userid"><i class="el-icon-star-on"></i> 主用户</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="姓名"
                    width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.name}}</span>
                      <svg-icon icon-class="client_man" class="user-sex" v-if="scope.row.sex === '男'" />
                      <svg-icon icon-class="client_women" class="user-sex" v-if="scope.row.sex === '女'" />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="职位"
                    width="140"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.positionname!=null&&scope.row.positionname!=''">{{scope.row.positionname}}</span>
                      <span v-if="scope.row.positionname==null||scope.row.positionname==''">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="导购员"
                    width="140"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.isshop===1" style="color: #67C23A">开启</span>
                      <span v-else style="color:#F56C6C">关闭</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="联系电话"
                    width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.tel!=null&&scope.row.tel!=''">{{scope.row.tel}}</span>
                      <span v-if="scope.row.tel==null||scope.row.tel==''" style="color:#999">未填写</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="微信"
                    width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.wchat!=null&&scope.row.wchat!=''">{{scope.row.wchat}}</span>
                      <span v-if="scope.row.wchat==null||scope.row.wchat==''" style="color:#999">未填写</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="邮箱"
                    min-width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.email!=null&&scope.row.email!=''">{{scope.row.email}}</span>
                      <span v-if="scope.row.email==null||scope.row.email==''" style="color:#999">未填写</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="使用状态"
                    width="160"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark==1">正常</el-tag>
                      <el-tag :disable-transitions="true" type="warning" size="mini" v-if="scope.row.mark==2">审核中</el-tag>
                      <el-tag :disable-transitions="true" type="warning" size="mini" v-if="scope.row.mark==3">未激活</el-tag>
                      <el-tag :disable-transitions="true" type="info" size="mini" v-if="scope.row.mark==4">已离职</el-tag>
                      <el-tag :disable-transitions="true" type="danger" size="mini" v-if="scope.row.mark==0">停用</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    align="center"
                    fixed="right"
                    width="120">
                    <template slot-scope="scope">
                      <el-dropdown v-if="scope.row.userid===delinfo.userid||scope.row.userid===user.userid" size="small" split-button icon="el-icon-edit">
                        <span style="color:#c0c4cc"><i class="el-icon-edit"></i> 编辑</span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-if="scope.row.userid===delinfo.userid||scope.row.userid===user.userid" style="color:#c0c4cc"><i class="el-icon-key"></i> 权限编辑</el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.userid===delinfo.userid||scope.row.userid===user.userid" style="color:#c0c4cc"><i class="el-icon-delete"></i> 删除用户</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-dropdown v-if="scope.row.userid!==delinfo.userid&&scope.row.userid!==user.userid" size="small" @click="editUser(scope.row)" split-button icon="el-icon-edit">
                        <i class="el-icon-edit"></i> 编辑
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-if="scope.row.mark===2" @click.native="auditUser(scope.row)"><i class="el-icon-check"></i> 审核通过</el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.userid!==delinfo.userid&&scope.row.userid!==user.userid" @click.native="roleEdit(scope.row)"><i class="el-icon-key"></i> 权限编辑</el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.userid!==delinfo.userid&&scope.row.userid!==user.userid" @click.native="delUser(scope.row)" style="color:#F56C6C"><i class="el-icon-delete"></i> 删除用户</el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.userid===delinfo.userid||scope.row.userid===user.userid" style="color:#c0c4cc"><i class="el-icon-key"></i> 权限编辑</el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.userid===delinfo.userid||scope.row.userid===user.userid" style="color:#c0c4cc"><i class="el-icon-delete"></i> 删除用户</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="totalUser>0"
                  background
                  @size-change="handleSizeChangeUser"
                  @current-change="handleCurrentChangeUser"
                  :current-page="currentPageUser"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSizeUser"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalUser">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editUserTitle"
      :visible.sync="editUserVisible"
      width="30%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="userForm" :model="userForm" :rules="userRules"  label-position="right" label-width="75px" size="small">
        <el-form-item label="登录名" prop="username">
          <el-input
            v-model="userForm.username"
            minlength="11"
            maxlength="11"
            :disabled="userForm.userid!=null">
            <template slot="append">请填写手机号码</template>
          </el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input
            type="password"
            v-model="userForm.password"
            minlength="6"
            maxlength="16"
            :disabled="isEditPaw">
            <template slot="append" v-if="userForm.userid!=null">
              <el-switch v-model="isEditPaw" @change="pawSwitch"></el-switch>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="用户姓名" prop="name">
          <el-input
            maxlength="10"
            v-model="userForm.name">
          </el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="userForm.sex">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input
            maxlength="20"
            v-model="userForm.tel">
          </el-input>
        </el-form-item>
        <el-form-item label="职位" prop="positionid">
          <el-select v-model="userForm.positionid" placeholder="请选择">
            <el-option
              v-for="item in positionList"
              :label="item.name"
              :value="item.positionid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="导购员" prop="isshop">
          <el-switch v-model="userForm.isshop"></el-switch>
          <span style="font-size: 12px;color: #9aaabf;margin-left: 10px">开启后将展示在门店小程序导购列表</span>
        </el-form-item>
        <el-form-item label="微信" prop="wchat">
          <el-input
            maxlength="20"
            v-model="userForm.wchat">
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            maxlength="60"
            v-model="userForm.email">
          </el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEditUser('userForm')">立即提交</el-button>
          <el-button @click="editUserVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="用户权限编辑"
      :visible.sync="roleUserVisible"
      width="30%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div style="color:#f56c6c;font-size: 12px;margin-bottom: 10px"><i class="el-icon-info"></i> 勾选 <b>预付款、尾款结清</b> 后该用户将可以查看订单金额，不勾选此两项则无法查看订单金额</div>
      <el-tree
        :data="roleData"
        v-loading="roleloading"
        v-model="roleForm.menuids"
        ref="roleTree"
        show-checkbox
        default-expand-all
        node-key="id"
        :props="defaultRoleProps">
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" :loading="editloading" @click="subEditRole">确定</el-button>
        <el-button size="mini" @click="roleUserVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审核用户"
      :visible.sync="auditUserVisible"
      width="30%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="auditForm" :model="auditForm" :rules="auditRules"  label-position="right" label-width="75px" size="small">
        <el-form-item label="登录名" prop="username">
          <el-input
            v-model="auditForm.username"
            :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="用户姓名" prop="name">
          <el-input
            :disabled="true"
            v-model="auditForm.name">
          </el-input>
        </el-form-item>
        <el-form-item label="职位" prop="positionid">
          <el-select v-model="auditForm.positionid" placeholder="请选择">
            <el-option
              v-for="item in positionList"
              :label="item.name"
              :value="item.positionid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="导购员" prop="isshop">
          <el-switch v-model="auditForm.isshop"></el-switch>
          <span style="font-size: 12px;color: #9aaabf;margin-left: 10px">开启后将展示在门店小程序导购列表</span>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="auditloading" @click="SubAudit('auditForm')">审核通过</el-button>
          <el-button @click="auditUserVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getDealerUserRole, editDealerUserRole, getDealerEditUserRole, checkRegisterDealerUser, getDealerPositionList } from '@/api/dealer'
import { getDealerDetail, getDealerUserList, updateDealerUserInfo, setMainOrDelDealerUser } from '@/api/work'
import { validatePhoneNumber } from '@/utils/validate'
export default {
  name: 'delrygl',
  computed: {
    user: getUser
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('请输入6-16位的登录密码'))
      } else {
        callback()
      }
    }
    return {
      searchForm: {
        searchUser: ''
      },
      editloading: false,
      loadingUser: false,
      tableDataUser: [],
      positionList: [],
      currentPageUser: 1,
      pageSizeUser: 20,
      totalUser: 0,
      editUserVisible: false,
      editUserTitle: '添加用户',
      isEditPaw: false,
      auditUserVisible: false,
      auditloading: false,
      userForm: {
        userid: null,
        username: '',
        password: '',
        name: '',
        sex: '',
        positionid: '',
        isshop: false,
        tel: '',
        wchat: '',
        email: ''
      },
      auditForm: {
        userid: null,
        username: '',
        name: '',
        positionid: '',
        isshop: false
      },
      userRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        name: [{ required: true, message: '请输入用户姓名', trigger: 'blur' }],
        positionid: [{ required: true, message: '请选择职位', trigger: 'change' }],
        tel: [{ required: true, trigger: 'blur', validator: validateUsername }]
      },
      auditRules: {
        positionid: [{ required: true, message: '请选择职位', trigger: 'change' }]
      },
      delinfo: [],
      roleUserVisible: false,
      roleData: [],
      roleForm: {
        userid: null,
        menuids: []
      },
      defaultRoleProps: {
        children: 'children',
        label: 'label'
      },
      roleloading: false
    }
  },
  created() {
    getDealerPositionList().then(response => {
      this.positionList = response.data
    })
    getDealerDetail({ delid: this.user.delid }).then(response => {
      this.delinfo = response.data
    }).catch(() => {})
    this.roleloading = true
    getDealerUserRole({ userid: this.user.userid }).then(response => {
      this.roleData = response.data
      this.roleloading = false
    }).catch(() => {
      this.roleloading = false
    })
    this.getUserData()
  },
  methods: {
    SearchUser() {
      if (this.searchForm.searchUser !== null && this.searchForm.searchUser.trim() !== '') {
        this.currentPageUser = 1
        this.getUserData()
      } else {
        this.searchForm.searchUser = ''
        this.getUserData()
      }
    },
    getUserData() {
      this.loadingUser = true
      const data = {
        delid: this.user.delid,
        content: this.searchForm.searchUser,
        page: this.currentPageUser,
        limit: this.pageSizeUser
      }
      getDealerUserList(data).then(response => {
        this.loadingUser = false
        this.tableDataUser = response.data
        this.totalUser = response.total
      }).catch(() => {
        this.loadingUser = false
      })
    },
    handleSizeChangeUser(val) {
      this.pageSizeUser = val
      this.getUserData()
    },
    handleCurrentChangeUser(val) {
      this.currentPageUser = val
      this.getUserData()
    },
    addUser() {
      this.editUserTitle = '添加用户'
      this.userForm.userid = null
      this.userForm.username = ''
      this.userForm.password = ''
      this.userForm.name = ''
      this.userForm.sex = ''
      this.userForm.tel = ''
      this.userForm.positionid = ''
      this.userForm.isshop = false
      this.userForm.wchat = ''
      this.userForm.email = ''
      this.isEditPaw = false
      this.userRules.password[0].required = true
      this.editUserVisible = true
    },
    editUser(row) {
      this.editUserTitle = '编辑用户'
      this.userForm.userid = row.userid
      this.userForm.username = row.username
      this.userForm.password = '****************'
      this.isEditPaw = true
      this.userForm.name = row.name
      this.userForm.isshop = row.isshop === 1 ? true : false
      this.userForm.positionid = row.positionid
      this.userForm.sex = row.sex
      this.userForm.tel = row.tel
      this.userForm.wchat = row.wchat
      this.userForm.email = row.email
      this.userRules.password[0].required = false
      this.editUserVisible = true
    },
    pawSwitch() {
      if (this.isEditPaw) {
        this.$refs['userForm'].clearValidate(['password'])
        this.userRules.password[0].required = false
        this.userForm.password = '****************'
      } else {
        this.userForm.password = ''
        this.userRules.password[0].required = true
      }
    },
    delUser(row) {
      this.$confirm('删除 “' + row.name + '” 用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setMainOrDelDealerUser({ userid: row.userid, delid: this.user.delid, type: 0 }).then(response => {
          this.$message({
            message: '用户已删除',
            type: 'success'
          })
          this.getUserData()
        }).catch(() => {})
      }).catch(() => {})
    },
    auditUser(row) {
      this.auditForm.userid = row.userid
      this.auditForm.username = row.username
      this.auditForm.name = row.name
      this.auditForm.positionid = ''
      this.auditForm.isshop = false
      this.auditUserVisible = true
    },
    SubAudit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.auditloading) {
            this.$confirm('审核通过 “' + this.auditForm.name + '” 用户, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.auditloading = true
              checkRegisterDealerUser({
                userid: this.auditForm.userid,
                positionid: this.auditForm.positionid,
                isshop: this.auditForm.isshop ? 1 : 0
              }).then(response => {
                this.$message({
                  message: '审核已通过',
                  type: 'success'
                })
                this.auditloading = false
                this.auditUserVisible = false
                this.getUserData()
              }).catch(() => {
                this.auditloading = false
              })
            }).catch(() => {})
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    subEditUser(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            let paw = ''
            if (!this.isEditPaw) {
              paw = this.userForm.password
            }
            const data = {
              userid: this.userForm.userid,
              delid: this.user.delid,
              username: this.userForm.username,
              password: paw,
              name: this.userForm.name,
              sex: this.userForm.sex,
              tel: this.userForm.tel,
              wchat: this.userForm.wchat,
              email: this.userForm.email,
              positionid: this.userForm.positionid,
              isshop: this.userForm.isshop ? 1 : 0
            }
            updateDealerUserInfo(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.editUserVisible = false
              this.editloading = false
              this.getUserData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    roleEdit(row) {
      this.roleForm.userid = row.userid
      this.roleUserVisible = true
      this.roleloading = true
      getDealerEditUserRole({ userid: this.roleForm.userid }).then(response => {
        this.$refs.roleTree.setCheckedKeys(response.data)
        this.roleloading = false
      }).catch(() => {
        this.roleloading = false
      })
    },
    subEditRole() {
      if (!this.editloading) {
        let menuids = []
        for (let menuid of this.$refs.roleTree.getCheckedKeys()) {
          if (!isNaN(menuid)) {
            menuids.push(menuid)
          }
        }
        this.roleForm.menuids = menuids
        this.editloading = true
        const data = {
          userid: this.roleForm.userid,
          menuids: this.roleForm.menuids.join(',')
        }
        editDealerUserRole(data).then(response => {
          this.$message({
            message: response.msg,
            type: 'success'
          })
          this.roleUserVisible = false
          this.editloading = false
        }).catch(() => {
          this.editloading = false
        })
      } else {
        return false
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.delrylb-container {
  .brand-info{
    margin:6px 0;
    .main-info{
      border-bottom: 1px solid #eee;
      position: relative;
      text-align: center;
    }
    .more-info{
      margin-top: 8px;
      .info-row{
        font-size: 12px;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        text-align: center;
        .title {
          font-size: 16px;
        }
        p {
          margin: 4px 0 !important;
          span{
            color:#99a9bf;
          }
        }
      }
    }
  }
  .add-btn{
    position: relative;
    float: right;
    margin-left: 10px;
    margin-top: -10px;
  }
  .search-mode{
    width: 300px;
    position: relative;
    float: right;
    margin-top: -10px;
    .search-input{
      background-color: #F2F6FC;
      border:0;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      color: #606266;
      padding: 0 40px 0 15px;
      -webkit-appearance: none;
      font-size: 12px;
      width: 100%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;
      &::-webkit-input-placeholder {
        color: #C0C4CC;
      }
      &::-ms-input-placeholder {
        color: #C0C4CC;
      }
    }
    .search-btn{
      position: absolute;
      right: 0;
      height: 40px;
      width: 40px;
      line-height: 40px;
      top: 0;
      border: 0;
      background: transparent;
      text-align: center;
      padding: 0;
    }
  }
  .card-content{
    .user-sex{
      width: 16px!important;
      height: 16px!important;
      vertical-align: -4px!important;
    }
    .el-table::before{
      height: 0!important;
    }
    .el-pagination{
      margin-top: 20px;
    }
  }
}
</style>
